import { TriggerForm } from "~/components/form/health-profile/TriggerForm";
import { Authorize } from "~/components/permission/Authorize";
import { useDismiss } from "~/providers/DismissProvider";

export default function CreateTrigger() {
    const { handleDismiss } = useDismiss();

    return (
        <Authorize ability="update" section="triggers">
            <TriggerForm onRequestClose={handleDismiss} asRoute />
        </Authorize>
    );
}
